module.exports = __webpack_public_path__ + "static/img/qcRobot.4ca4ad8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qcRobot.png
// module id = XPNl
// module chunks = 1